import { useMediaQuery } from 'react-responsive';

const useMobileMediaQuery = () => useMediaQuery({ maxWidth: 767 });

export { useMobileMediaQuery };
